import React, { useEffect, useState } from "react";
import MainContainer from "../../components/main-container/MainContainer";
import { Autocomplete, Button, Divider, TextField } from "@mui/material";
import { Language_Models } from "../../constants/AppConstant";
import { InvokePostServiceCall } from "../../api/apiServices";
import { useLocation, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { marked } from "marked";
import { Markup } from "interweave";
import styled from "styled-components";
import { API } from "../../constants/APIConstant";

export const ConvoDiv = styled.div`
  border: 0.5px solid grey;
  padding: 10px;
  border-radius: 15px;
  margin: 2%;

  .copy-icon {
    float: right;
    cursor: pointer;
    display: none;
    opacity: 0.2;
    transition: opacity 0.3s;

    &:hover {
      opacity: 1;
    }
  }

  &:hover .copy-icon {
    display: block;
    opacity: 0.2;
  }
`;

function CompareDetails() {
  const { id } = useParams();
  const { state } = useLocation();
  const [languageModel, setLanguageModel] = useState({
    title: "GPT-4 Turbo Preview (Open AI)",
    value: "gpt-4-0125-preview",
  });
  const [pdfOne, setPdfOne] = useState("");
  const [pdfTwo, setPdfTwo] = useState("");
  const [showSpinner, setShowSpinner] = useState(false);
  const [compareResult, setCompareResult] = useState(null);
  const [projectInfo, setProjectInfo] = useState([]);
  const notify = () => toast.error(`Something went wrong!`);

  const handleInfo = () => {
    let requestBody = {
      project_name: id,
    };

    InvokePostServiceCall(API.compareDocuments_get_project_files, requestBody)
      .then((response) => response.json())
      .then((result) => {
        console.log(result, "result");
        let tempArr = [];
        result.pdf_list.forEach((item) => {
          let res = item.split("/")[item.split("/").length - 1];
          console.log(res);
          tempArr.push(res);
        });
        setProjectInfo(tempArr);
      })
      .catch((error) => {
        console.error(error);
        notify();
      });
  };

  const handleCompare = async () => {
    try {
      setShowSpinner(true);
      const requestBody = {
        folder_name: id,
        created_by: state.createdBy,
        model_name: languageModel.value,
        pdf1: pdfOne,
        pdf2: pdfTwo,
      };

      let response = await InvokePostServiceCall(
        API.compareDocuments_compare_pdfs,
        requestBody
      );
      setShowSpinner(false);
      if (!response.ok || !response.body) {
        throw response.statusText;
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let tempData = "";

      while (true) {
        const { value, done } = await reader.read();
        if (done) {
          // setLoading(false);
          break;
        }
        let decodedChunk = decoder.decode(value, { stream: true });

        tempData += decodedChunk;

        setCompareResult({
          name: `${pdfOne},${pdfTwo}`,
          response: marked(tempData),
        });
      }
    } catch (error) {
      notify();
      console.log(error);
    }
  };

  useEffect(() => {
    handleInfo();
  }, []);

  return (
    <MainContainer showHomeButton={true}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          margin: "10px 10px 0px 10px",
        }}
      >
        {/* <TextField
          variant="outlined"
          //   label="Project Name"
          placeholder="Project Name"
          size="small"
        /> */}
        <Autocomplete
          disableClearable
          value={pdfOne}
          onChange={(event, newValue) => {
            setPdfOne(newValue);
          }}
          size="small"
          options={projectInfo}
          // getOptionLabel={(option) => option.title}
          sx={{
            width: "300px",
            backgroundColor: "white",
            borderRadius: "5px !important",
            marginRight: "10px",
            // marginLeft: "10px",
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              // variant="standard"
              sx={{
                backgroundColor: "white",
                borderRadius: "5px !important",
              }}
              // label="Language Model *"
              placeholder="Select PDF1 *"
            />
          )}
        />
        <Autocomplete
          disableClearable
          value={pdfTwo}
          onChange={(event, newValue) => {
            setPdfTwo(newValue);
          }}
          size="small"
          options={projectInfo}
          // getOptionLabel={(option) => option.title}
          sx={{
            width: "300px",
            backgroundColor: "white",
            borderRadius: "5px !important",
            marginRight: "10px",
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              // variant="standard"
              sx={{
                backgroundColor: "white",
                borderRadius: "5px !important",
              }}
              // label="Language Model *"
              placeholder="Select PDF2 *"
            />
          )}
        />
        <Autocomplete
          disableClearable
          value={languageModel}
          defaultValue={languageModel}
          onChange={(event, newValue) => {
            setLanguageModel(newValue);
          }}
          size="small"
          options={Language_Models}
          getOptionLabel={(option) => option.title}
          sx={{
            width: "300px",
            backgroundColor: "white",
            borderRadius: "5px !important",
            marginRight: "10px",
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              // variant="standard"
              sx={{
                backgroundColor: "white",
                borderRadius: "5px !important",
              }}
              // label="Language Model *"
              placeholder="Language Model *"
            />
          )}
        />

        <Button
          variant="contained"
          sx={{
            backgroundColor: "#004987",
            "&:hover": { backgroundColor: "#004987" },
          }}
          onClick={() => {
            handleCompare();
          }}
          disabled={!pdfOne || !pdfTwo}
        >
          Compare
          {showSpinner && <Spinner size="sm" style={{ marginLeft: "5px" }} />}
        </Button>
      </div>
      <ToastContainer />
      {compareResult?.name && (
        <ConvoDiv
          // key={index}
          className={`old-chat ${"h-auto"}`}
        >
          <div className="user-info" style={{ position: "relative" }}>
            <div className="user-info-details">
              <div className="w-100">
                <strong>PDF 1:</strong>{" "}
                <span>
                  <a
                    href={
                      compareResult?.name.split(",")[0].includes("https://")
                        ? compareResult?.name.split(",")[0]
                        : `https://vs-knowledgebase-documents-habilis-dev.s3.amazonaws.com/compare-documents/${id}/${
                            compareResult?.name.split(",")[0]
                          }`
                    }
                  >{` ${
                    compareResult?.name.split(",")[0].split("/")[
                      compareResult?.name.split(",")[0].split("/").length - 1
                    ]
                  }`}</a>
                </span>
              </div>
              <div className="w-100">
                <strong>PDF 2:</strong>{" "}
                <span>
                  <a
                    href={
                      compareResult?.name.split(",")[1].includes("https://")
                        ? compareResult?.name.split(",")[1]
                        : `https://vs-knowledgebase-documents-habilis-dev.s3.amazonaws.com/compare-documents/${id}/${
                            compareResult?.name.split(",")[1]
                          }`
                    }
                  >{` ${
                    compareResult?.name.split(",")[1].split("/")[
                      compareResult?.name.split(",")[1].split("/").length - 1
                    ]
                  }`}</a>
                </span>
              </div>
            </div>
          </div>
          <Divider sx={{ border: "1px solid black", marginTop: "5px" }} />

          <div className="response-container evr-response-use-model ">
            <div className="d-flex flex-column w-100">
              <Markup content={compareResult?.response} />
            </div>
          </div>
        </ConvoDiv>
      )}
    </MainContainer>
  );
}

export default CompareDetails;
